<i18n src="@/locales/modules/RequestTranslate.json"></i18n>

<template>
	<div class="list-requests-dashboard cbs-custom-table pb-3 cursor-pointer" @click.stop.self="handleRedirect">
		<div class="header">
			<h4 class="header__title pt-6 pl-6">Lịch sử hoạt động</h4>
		</div>
		<div class="flex gap-5 mt-5 flex-wrap justify-center items-center px-6">
			<div class="history__controls">
				<chevron-left-icon
					size="1.5x"
					class="history__controls__button"
					@click="changeDate(-1)"
				></chevron-left-icon>
				<span class="history__controls__date">{{ formatDate(dateStart) }}</span>
				<chevron-right-icon
					size="1.5x"
					:class="[
				'history__controls__button',
				{ 'history__controls__button--disabled': isNextDate() },
				]"
					@click="!isNextDate() && changeDate(1)"
				></chevron-right-icon>
			</div>
			<vs-input
				@input="() => { currentPage = 1; getActivityHistory(); }"
				class="md:ml-auto ml-0 md:order-0 order-1 w-20"
				:placeholder="'Số lượng'"
				v-model="limit"
			/>
			<vs-input
				class="ml-0 md:order-0 order-1"
				icon="search"
				:placeholder="'Nhập mã'"
				v-model="searchText"
			/>
		</div>
		<activity-table class="px-6" :isQuickMode="true" :data="activityHistory"/>

		<cbs-pagination
			class="mt-3"
			:total="totalPages"
			v-model="currentPage"
			v-if="activityHistory && activityHistory.length"
		/>
	</div>
</template>

<script>
import axios from "axios";
import ActivityTable from "@/components/cbs-activity/ActivityTable";
import {ChevronLeftIcon, ChevronRightIcon} from "vue-feather-icons";
import vSelect from "vue-select";

export default {
	name: "ListActivities",
	components: {
		ActivityTable,
		ChevronLeftIcon,
		ChevronRightIcon,
		vSelect,
	},
	emits: {
		onIsRequestFormDirtyChange: {},
	},
	data() {
		const today = new Date();
		return {
			limit: 5,
			currentPage: 1,
			totalActivities: 0,
			searchText: "",
			activityHistory: [],
			dateStart: new Date(
				today.getFullYear(),
				today.getMonth(),
				today.getDate(),
				0,
				0,
				0
			),
			dateEnd: new Date(
				today.getFullYear(),
				today.getMonth(),
				today.getDate() + 1,
				0,
				0,
				0
			),
		};
	},
	computed: {
		totalPages() {
			return Math.ceil(this.totalActivities / this.limit);
		},
	},
	watch: {
		currentPage() {
			this.getActivityHistory();
		},
		"$route.query"() {
			this.getActivityHistory();
		},
	},
	methods: {
		isNextDate() {
			const today = new Date();
			today.setDate(today.getDate());
			return this.dateEnd >= today;
		},
		formatDate(date) {
			return `${String(date.getDate()).padStart(2, "0")}-${String(
				date.getMonth() + 1
			).padStart(2, "0")}-${date.getFullYear()}`;
		},
		formatAPIDate(date) {
			return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
				2,
				"0"
			)}-${String(date.getDate()).padStart(2, "0")} 00:00:00`;
		},
		async getActivityHistory() {
			try {
				this.$vs.loading();
				const response = await axios.post("https://canhbaosom.com/ktx-camera-api", {
					url: this.$constant.API_URL_CAMERA_CMD + "/events",
					params: {
						EventType: "Face",
						IsInRoi: true,
						DateStart: this.formatAPIDate(this.dateStart),
						DateEnd: this.formatAPIDate(this.dateEnd),
						StartIndex: this.limit * (this.currentPage - 1),
						EndIndex: this.limit * this.currentPage,
						HourOffset: 7,
						SortBy: "time",
						SortDirection: "desc",
						PersonID: this.searchText === "" ? null : this.searchText,
					},
				});
				this.activityHistory = response.data.Records || [];
				this.totalActivities = response.data.TotalRecords || 0;
				this.$vs.loading.close();
			} catch (error) {
				console.error("Error fetching activity history:", error);
			}
		},
		changeDate(dayOffset) {
			this.dateStart.setDate(this.dateStart.getDate() + dayOffset);
			this.dateEnd.setDate(this.dateEnd.getDate() + dayOffset);
			this.getActivityHistory();
		},
		handleRedirect(e) {
			this.$router.push(this.$constant.PAGES_PATH.PAGE_CBS_ACTIVITY_PATH).catch(() => {});
			e.stopPropagation();
		}
	},
	mounted() {
		this.getActivityHistory();
	},
};
</script>

<style lang="scss">
.vs-icon {
	border: none !important;
}

.history {
	&__controls {
		display: flex;
		justify-content: center;
		align-items: center;
		margin: 10px auto 0;
		gap: 1rem;

		&__button {
			display: flex;
			justify-content: center;
			align-items: center;
			border: 2px solid #000000;
			color: #000000;
			border-radius: 50%;
			cursor: pointer;
			width: 21px;
			height: 21px;

			&--disabled {
				border-color: #cccccc;
				color: #cccccc;
				cursor: not-allowed;
			}

			&:hover {
				opacity: 0.8;
			}
		}

		&__date {
			font-size: 1.25rem;
			font-weight: 700;
			color: #111827;
		}
	}
}
</style>
